import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Color, Path, Svg } from "react-native-svg";

const SvgUser: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style, color }) => (
  <Svg style={style} viewBox="0 0 17 19" fill="none">
    <Path
      d="M8.8 12c-3 0-5.5-2.5-5.5-5.5S5.8 1 8.8 1s5.5 2.5 5.5 5.5S11.9 12 8.8 12Zm0-10C6.3 2 4.3 4 4.3 6.5s2 4.5 4.5 4.5 4.5-2 4.5-4.5S11.3 2 8.8 2ZM1.9 18.7l-.9-.4c1.4-3.1 4.4-5.1 7.8-5.1 3.4 0 6.4 2 7.8 5.1l-.9.4c-1.2-2.7-3.9-4.5-6.9-4.5-3 0-5.7 1.8-6.9 4.5Z"
      fill={color || "#000"}
      stroke={color || "#000"}
      strokeWidth={0.2}
    />
  </Svg>
);

export default SvgUser;
